const typographyformCreateUser = {
  text: 'Registro de Nuevo Usuario'
};

export default typographyformCreateUser;
